export default {
    SEAMONKEY: 'Seamonkey',
    FIREFOX: 'Firefox',
    EDGE: 'Edge',
    OPERA: 'Opera',
    INTERNET_EXPLORER: 'Internet Explorer',
    CHROMIUM: 'Chromium',
    CHROME: 'Chrome',
    SAFARI: 'Safari',
    OUTRO: 'Outro'
}